var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToastSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.3999C7.19842 2.3999 2.90002 6.6983 2.90002 11.9999C2.90002 17.3015 7.19842 21.5999 12.5 21.5999C17.8016 21.5999 22.1 17.3015 22.1 11.9999C22.1 6.6983 17.8016 2.3999 12.5 2.3999ZM17.8656 10.1655L11.8176 16.2135C11.6672 16.3639 11.464 16.4479 11.252 16.4479C11.04 16.4479 10.836 16.3639 10.6864 16.2135L7.92402 13.4511C7.61122 13.1383 7.61122 12.6327 7.92402 12.3199C8.23682 12.0071 8.74242 12.0071 9.05522 12.3199L11.252 14.5167L16.7344 9.0343C17.0472 8.7215 17.5528 8.7215 17.8656 9.0343C18.1784 9.3471 18.1784 9.8527 17.8656 10.1655Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.3999C7.19842 2.3999 2.90002 6.6983 2.90002 11.9999C2.90002 17.3015 7.19842 21.5999 12.5 21.5999C17.8016 21.5999 22.1 17.3015 22.1 11.9999C22.1 6.6983 17.8016 2.3999 12.5 2.3999ZM17.8656 10.1655L11.8176 16.2135C11.6672 16.3639 11.464 16.4479 11.252 16.4479C11.04 16.4479 10.836 16.3639 10.6864 16.2135L7.92402 13.4511C7.61122 13.1383 7.61122 12.6327 7.92402 12.3199C8.23682 12.0071 8.74242 12.0071 9.05522 12.3199L11.252 14.5167L16.7344 9.0343C17.0472 8.7215 17.5528 8.7215 17.8656 9.0343C18.1784 9.3471 18.1784 9.8527 17.8656 10.1655Z",
    fill: "url(#paint0_linear_3945_20039)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8656 10.1655L11.8176 16.2135C11.6672 16.3639 11.464 16.4479 11.252 16.4479C11.04 16.4479 10.836 16.3639 10.6864 16.2135L7.92402 13.4511C7.61122 13.1383 7.61122 12.6327 7.92402 12.3199C8.23682 12.0071 8.74242 12.0071 9.05522 12.3199L11.252 14.5167L16.7344 9.0343C17.0472 8.7215 17.5528 8.7215 17.8656 9.0343C18.1784 9.3471 18.1784 9.8527 17.8656 10.1655Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3945_20039",
    x1: 2.90002,
    y1: 11.9999,
    x2: 22.1,
    y2: 11.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207692,
    stopColor: "#DEA64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351282,
    stopColor: "#FFEB95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489744,
    stopColor: "#EFBC68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607692,
    stopColor: "#FFD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74359,
    stopColor: "#BE8D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6C0C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastSuccessIcon);
export default __webpack_public_path__ + "static/media/toast-success-icon.dedea3877fbcd5c10cc1d7f9a3439dc4.svg";
export { ForwardRef as ReactComponent };